module.exports = __webpack_public_path__ + "media/rank.6b6fa1a1.mp4";